@if (itemsLoaded) {
  <div>
    <h1>{{title}}</h1>
    <table class="table-chart">
      <thead>
        <tr>
          @for (column of tableData.Columns; track column) {
            <th>
              {{column.HeaderText}}
            </th>
          }
          @if (totalSum == 'True') {
            <th>Skupna vsota</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (dataItem of tableData.Items; track dataItem) {
          <tr class="table-chart-row">
            @for (column of tableData.Columns; track column) {
              <td>
                {{resolvePropertyBinding(dataItem.KeyValue,column.Binding)}}
              </td>
            }
            @if (totalSum == 'True') {
              <td>
                {{resolvePropertyBinding(dataItem.KeyValue,'TotalCount')}}
              </td>
            }
          </tr>
        }
        @if (totalSum == 'True') {
          <tr>
            <td>Skupna vsota</td>
            @for (item of totals; track item) {
              <td>
                {{item}}
              </td>
            }
            <td>
              {{totalCountAll}}
            </td>
          </tr>
        }
      </tbody>
      @if (showPagination()) {
        <tfoot>
          <tr>
            <td attr.colspan="{{footerColSpan}}">
              @if (itemsLoaded) {
                <div class="tabledatachart-table-footer pagination">
                  @if (previousPage > 0) {
                    <div class="left-double left-double-table-chart" (click)="toFirstPage()"></div>
                  }
                  @if (previousPage != 0) {
                    <div class="left left-table-chart" (click)="pageChanged(previousPage)"></div>
                  }
                  @for (page of pages; track page) {
                    <p [ngClass]="{'active': page.Active == true}"
                      (click)="pageChanged(page.Number)">
                    {{page.Number}}</p>
                  }
                  @if (nextPage != 0) {
                    <div class="right right-table-chart" (click)="pageChanged(nextPage)"></div>
                  }
                  @if (nextPage > 0) {
                    <div class="right-double right-double-table-chart" (click)="toLastPage()"></div>
                  }
                </div>
              }
            </td>
          </tr>
        </tfoot>
      }
    </table>
  </div>
}
